<template>
  <div
    class="p-1 flex w-full md:mt-[26px]"
    :class="[
      isMobileTop ? 'mx-2' : '',
      expanded ? 'justify-start items-start' : 'justify-center items-center'
    ]"
  >
    <component :is="expanded ? AceLogoExpandedIcon : AceLogoIcon" />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { AceLogoIcon, AceLogoExpandedIcon } from '../../icons'
import { navigationStore } from '../store/navigationStore'

export default defineComponent({
  name: 'NavigationPaneBrand',
  components: {
    AceLogoIcon,
    AceLogoExpandedIcon
  },
  props: {
    expanded: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const isMobile = computed(() => navigationStore.state.isMobile)
    const effectivePosition = computed(() => navigationStore.state.effectivePosition)
    const isMobileTop = computed(() => isMobile.value && effectivePosition.value === 'top')

    return {
      isMobileTop,
      AceLogoIcon,
      AceLogoExpandedIcon
    }
  }
})
</script>
